import * as React from 'react';
import classNames from 'classnames';

/**
 * @param title 标题
 * @param extra actions
 */
type HeadingProps = {
  title: React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
};

function Heading({ title, extra = null, className = '' }: HeadingProps) {
  return (
    <div className={classNames('heading flex mb-md items-center', className)}>
      <div className="heading-title pl-sm mr-md text-lg font-bold border-l-2 border-solid border-blue-400">
        {title}
      </div>
      {extra}
    </div>
  );
};

export default Heading;
